import {
  SHTableCell,
  SHTableCellProps,
  SHTypography,
} from "@components/design-systems";
import { useTheme } from "@mui/material";
import { hexToRGBA } from "@utils";
import { ReactNode } from "react";

interface FeePortfolioDetailsTableCellProps extends SHTableCellProps {
  children: ReactNode;
  isFirstRow?: boolean;
}

export const FeePortfolioDetailsTableCell = ({
  children,
  isFirstRow,
  ...others
}: FeePortfolioDetailsTableCellProps) => {
  const { palette } = useTheme();
  return (
    <SHTableCell
      sx={{
        height: "50px",
        borderLeft: `solid 1px ${hexToRGBA(palette.primary[50], 0.3)}`,
        backgroundColor: isFirstRow ? undefined : palette.secondary[50],
        width: isFirstRow ? "360px" : undefined,
      }}
      {...others}
    >
      <SHTypography
        variant={isFirstRow ? "subtitle2" : "body1"}
        colorVariant={isFirstRow ? "primary" : "third"}
        lineHeight={"120%"}
      >
        {children}
      </SHTypography>
    </SHTableCell>
  );
};
